import type { JsonApiObject } from '@shared/helpers/jsonapi';
import { deserialize } from '@shared/helpers/jsonapi';

import type { ApiOptions } from '../ApiProvider';
import Api from '../ApiProvider';
import type { DeserializedTokenData, DeserializedTokenPrice, TokenPeriodDeprecated } from './types';

export type GetTokenSearchParamsDeprecated = {
  period?: TokenPeriodDeprecated;
};

/**
 * @deprecated use /coins
 */
export const getToken = async (
  tokenId: string,
  options?: ApiOptions<{ searchParams?: GetTokenSearchParamsDeprecated }>,
) => {
  const data = await Api.get(`v2/quote/token/${tokenId}`, options).json<JsonApiObject>();

  return deserialize<DeserializedTokenData>(data);
};

/**
 * @deprecated use /coins
 */
export const getTokenChart = async (
  tokenId: string | number,
  options: ApiOptions<{ searchParams?: GetTokenSearchParamsDeprecated }>,
) => {
  const data = await Api.get(`v2/quote/token/${tokenId}/chart`, options).json<JsonApiObject>();

  return deserialize<DeserializedTokenData>(data);
};

/**
 * @deprecated use /coins
 */
export const getSqrTokenPrice = async (options?: ApiOptions) => {
  const data = await Api.get('v2/quote/token/sqr/price', options).json<JsonApiObject>();

  return deserialize<DeserializedTokenPrice>(data);
};
